import React, { useState, useEffect } from 'react';

const AgeCounter = () => {
  const [age, setAge] = useState('');

  useEffect(() => {
    // Coin creation timestamp: October 26, 2025, 3:00:36 PM EST
    // EST is UTC-5, so 3:00:36 PM EST = 8:00:36 PM UTC
    const creationDate = new Date('2025-10-26T20:00:36.000Z');

    const updateAge = () => {
      const now = new Date();
      const diffMs = now - creationDate;

      // Calculate days, hours, minutes, and seconds
      const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      setAge(`${days}d ${hours}h ${minutes}m ${seconds}s`);
    };

    // Update immediately
    updateAge();

    // Update every second
    const interval = setInterval(updateAge, 1000);

    // Cleanup interval on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{
      fontSize: '18px',
      color: 'var(--text-primary)',
      padding: '10px 20px',
      textAlign: 'center',
      fontWeight: '500',
      width: '100%',
      position: 'relative',
      zIndex: '100',
      marginTop: '-60px',
      paddingTop: '10px',
      fontFamily: 'var(--font-main)'
    }}>
      Age: {age}
    </div>
  );
};

export default AgeCounter;
